import React, { Component, Fragment } from 'react';
import { toast } from 'react-toastify';
import { Row, Col, Card, Button } from 'antd';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';

import { project_show, project_application, projects } from 'constants/routes';
import { patchApplication, postApplication } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';
import Text from 'components/common/form/Text';
import Files from 'components/common/form/Files';
import ApplicationDistributorSelect from './ApplicationDistributorSelect';
import MaskedPhoneInput  from 'components/common/form/MaskedPhoneInput';

const SUPPORTED_FORMATS = ["doc", "xls", "ppt","png", "jpg", "tif", "pdf", "xlsx"]

const validationSchema = yup.object({
    project_id: yup.string().Integer().required(),
    name: yup.string().required(),
    files: yup.mixed().test(
        'format',
        'Неподдерживаемый формат',
        (value) => !value ? true : value.map(item => item.name.split('.').pop()).every(item=>  SUPPORTED_FORMATS.includes(item))
    ),
    description: yup.string().required(),
    distributor_id: yup.string().required(),
    contact_email: yup.string().email().nullable(),
    contact_phone: yup.string().required().min(11),
    contact_name: yup.string().nullable().matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    contact_surname: yup.string().nullable().matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    contact_patronymic: yup.string().nullable().matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    finishing_date: yup.string().date().nullable(),
    status: yup.string().nullable(),
});
@withAutoFocusForm
@withAsyncActions(({ isEdit, inProjectAdd }) => ({
    formAction: (isEdit ?  patchApplication : postApplication)
        .withSuccessHandler(({ history, project_id, application_id, initialValues, clearProjectId }) => {
            if (isEdit) {
                toast("Ваша заявка на смену дистрибьютора принята. Ожидайте подтверждения.");
                history.push(project_application.stringify({ project_id: project_id, id: application_id || initialValues.id }));
            } else if (inProjectAdd) {
                clearProjectId()
                return history.push(projects.stringify());
            } else {
                history.push(project_show.stringify({ id: project_id }));
            }
        }),
}))
@withForm({
    validationSchema,
})
export default class ApplicationForm extends Component {

    render() {
        const location = this.props.changelocation || { location: this.props.location.pathname }
        return (
            <Fragment>
                <div className="application-cards">
                    <div className="application-card-left">
                        <Card title="Информация о заявке" bordered={false}>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='name'
                                        component={Input}
                                        placeholder='Название заявки'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='description'
                                        component={Text}
                                        placeholder='Краткое описание'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} className="form-label">
                                    Материалы
                                </Col>
                                <Col xs={24} className="form-sub-label">
                                    Загрузите вспомогательные материалы о проекте(дизайн-проект, описание, техническое задание и т.п.)
                                </Col>
                                <Col xs={24} className="form-sub-label">
                                (При наличии загрузите план электрики или спецификацию)
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        value=""
                                        name='files'
                                        component={Files}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} className="form-label">
                                    Поставщик
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        regionPath={location}
                                        name='distributor_id'
                                        component={ApplicationDistributorSelect}
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </div>
                    <div className="width210">
                        <Card title="Контактное лицо" bordered={false}>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='contact_surname'
                                        component={Input}
                                        placeholder='Фамилия'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='contact_name'
                                        component={Input}
                                        placeholder='Имя'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='contact_patronymic'
                                        component={Input}
                                        placeholder='Отчество'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='contact_email'
                                        component={Input}
                                        placeholder='E-mail'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='contact_phone'
                                        component={MaskedPhoneInput}
                                        placeholder='Телефон'
                                    />
                                </Col>
                            </Row>
                        </Card>
                    </div>
                </div>
                <Row className="controls" gutter={20}>
                    <Col xs={24}>
                        <br />
                        <Button type="primary" htmlType="submit" className="sm-l-m-20">
                            Сохранить
                        </Button>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ApplicationForm.js